import { IUserUpdateInfo } from 'src/redux/api/authApi';
import { apiClient } from './backendURL';

export const getUserInfoAPI = (token: any) =>
    apiClient.get('user/getuser', {
        headers: {
            authorization: token,
        },
    });

export const updateUserInfoAPI = (token: any, userUpdateInfo: IUserUpdateInfo) =>
    apiClient.patch('user/updateuser', userUpdateInfo, {
        headers: {
            authorization: token,
        },
        params: {
            id: userUpdateInfo.id,
        },
    });

export const getAllUsersAPI = (token: any) =>
    apiClient.get('user/getAllUsers', {
        headers: {
            Authorization: token,
        },
    });

// Cart API functions
export const addToCartAPI = (token: any, productId: string) =>
    apiClient.post('cart/add', { productId }, {
        headers: {
            authorization: token,
        },
    });

export const getCartAPI = (token: any) =>
    apiClient.get('cart', {
        headers: {
            authorization: token,
        },
    });

export const removeFromCartAPI = (token: any, productId: string, removeAll: boolean = true) =>
    apiClient.delete('cart/remove', {
        headers: {
            authorization: token,
        },
        data: { productId, removeAll },
    });

